import { FC, useEffect, useState } from "react";
import { Button } from "../../components/ui-kit/RoundButton";
import { getMVPList } from "../../api/transport/configurationTransport";
import { MVPCardInfo } from "../../types/configuration";

interface FanMVPListWidgetProps {
    maxCount?: number;
    showAllUrl?: string;
}

export const FanMVPListWidget: FC<FanMVPListWidgetProps> = ({
    maxCount,
    showAllUrl,
}) => {
    const [players, setPlayers] = useState<MVPCardInfo[]>([]);

    useEffect(() => {
        getMVPList().then(data => {
            if (maxCount && maxCount < data.length) {
                setPlayers(data.slice(-maxCount));
            } else {
                setPlayers(data);
            }
        })
    }, []);

    return (
        <div className="w-full">
            <div className="flex flex-row justify-center items-center gap-4 flex-wrap">
                {players.map((p, index) => {
                    return (
                        <a href={p.linkUrl} title="К профилю игрока" key={p.id} target="_blank" rel="noreferrer" className="max-w-1/3 w-96">
                            <img
                                src={p.imageUrl}
                                alt={p.name}
                                className="transition-all w-full opacity-95 rounded hover:scale-105 hover:opacity-100 hover:-translate-y-4"
                            />
                        </a>
                    )
                })}
            </div>
            {showAllUrl && (
                <div className="text-center pt-4" style={{ fontFamily: 'Futura' }}>
                    <Button
                        title="Посмотреть всех"
                        href={showAllUrl}
                        className="border-1 border-solid border-white mx-auto !bg-sky-950 !border-1 !rounded-full !font-bold italic text-3xl shadow !text-white hover:!bg-sky-900"
                    />
                </div>
            )}
        </div>
    )
}
